import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCRJbaL5y1IkO-MvSLfl56eAIbCdJ6uQy8",
  authDomain: "samriddhi-health.firebaseapp.com",
  projectId: "samriddhi-health",
  storageBucket: "samriddhi-health.firebasestorage.app",
  messagingSenderId: "850622578053",
  appId: "1:850622578053:web:721879139660de4bd858ec",
  measurementId: "G-4BDJ4WDBC9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
